module.exports = __webpack_public_path__ + "static/media/coccinelle.0b5041f6.png";